import type { SftpTenantConfigDocument } from '@/services/graphql';

export const sourcePasswordForUpdate = (password: string): string | null => password || null;

export const connectionStringForAdd = (connectionString?: string): string => connectionString ?? '';

export const connectionStringForUpdate = (connectionString?: string): string | null => connectionString || null;

export const toCloneValues = (config: SftpTenantConfigDocument) => ({
  configName: `${config.configName} (Copy)`,
  podId: config.podId,
  enabled: false,
  batchSize: config.batchSize,
  sourceType: config.source.type,
  sourceEndpoint: config.source.endpoint,
  sourcePort: config.source.port,
  sourceDirectory: config.source.directory,
  sourceUsername: config.source.username,
  sourceFilePattern: config.source.filePattern,
});
